import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import ManagedSolutionsApplicationFormsTable from "../../components/ManagedSolutionsApplicationForms/ManagedSolutionsApplicationFormsTable"
import {usePaging} from "../../hooks/usePaging"
import {useAccessToken} from "../../services/auth"
import {
	findManagedSolutionsApplicationForms,
	exportManagedSolutionsApplicationForms,
} from "../../resources/managedSolutions"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableActionHeader, DataTableCard, TablePending} from "../../components/DataTable/DataTable"
import {useQueryState} from "use-location-state"
import {downloadFile} from "../../utilities/file"
import {useToasts} from "react-toast-notifications"

export function ManagedSolutionsApplicationFormsPage(): ReactElement {
	const accessToken = useAccessToken()
	const {addToast} = useToasts()
	const limit = 40

	const [sortBy, setSortBy] = useQueryState("rtl-app-form--sort", "-createdAt")

	const [result, hasPrev, hasNext, prev, next, hasResults, reset] = usePaging(
		limit,
		(offset, limit) => findManagedSolutionsApplicationForms(accessToken, offset, limit, sortBy),
		(x) => x.data.length,
		[sortBy],
		"rtl-app-form",
		true
	)

	const toggleSort = () => {
		setSortBy(sortBy === "-createdAt" ? "createdAt" : "-createdAt")
		reset(limit)
	}

	async function exportApplicationForms() {
		const response = await exportManagedSolutionsApplicationForms(accessToken, sortBy)
		response.match(
			(d) => downloadFile("ManagedSolutionsApplicationForms.csv", d, "text/csv"),
			() => addToast("Something went wrong", {appearance: "warning"})
		)
		return true
	}

	return (
		<>
			<TitleBar title={"Application Forms"} />

			<MainSectionTable>
				<DataTableCard className={"managed-solutions-application-forms-card"}>
					<DataTableActionHeader enableSticky={true} exportFunc={exportApplicationForms} />
					<AsyncResultComponent asyncResult={result} pendingComponent={<TablePending numberOfRows={2} />}>
						{({value: applicationForms}) => {
							return (
								<ManagedSolutionsApplicationFormsTable
									applicationForms={applicationForms.data}
									hasResults={hasResults}
									hasPrev={hasPrev}
									hasNext={hasNext}
									prev={prev}
									next={next}
									isUsingPaging={true}
									fullHeight={true}
									meta={applicationForms.meta}
									sortBy={sortBy}
									sortFunction={toggleSort}
								/>
							)
						}}
					</AsyncResultComponent>
				</DataTableCard>
			</MainSectionTable>
		</>
	)
}
